<template>
  <div class="routine-finder-product-retailer">
    <div class="routine-finder-product-retailer__cta">
      <button v-truncate-rich-text="{ limit: 12, ellipse: false, singleLine: true }" @click.stop="openRetailer()"
        class="buyBtn">{{ ctaLable }}</button>
    </div>
    <div class="popupContainerOuter-overlay" @click.stop :class="{ 'showPopup': showPopup }"></div>
    <div class="popupContainerOuter popupWrapper" @click.stop id="popupContainerOuter"
      :class="{ 'showPopup': showPopup }" :id="`popupContainerOuterRetailer-${uniqueId}`">

      <div class="popupRetailer">
        <div class="popup-title__container">
          <h2 class="popup-heading"><span v-if="enableBuynowSortOption">{{retailerDictionaryDatas.buyOnline}}</span></h2>
          <button class="popupCLose" @click.stop="closePopupScreen()"></button>
        </div>
        <h3 class="popup-slectShop" v-if="enableBuynowSortOption && retailerdata.length > 0">{{retailerDictionaryDatas.selectShop}}</h3>
        <div class="retailer-sorting__container" v-if="enableBuynowSortOption && retailerdata.length > 0">

          <customSorting ref="retailer_sorting" :sortlabel="retailerDictionaryDatas.sortBy" :options="retailerDictionaryDatas.sortByOptions" :default="retailerDictionaryDatas.defaultText" class="select"
            @getInput="sortOrder = $event" />
        </div>
        <div>

          <div class="retailer-count" v-if="enableBuynowSortOption && retailerdata.length > 0"> {{ sortedItems.length }} {{retailerDictionaryDatas.onlineShoping}}</div>
          <div id="commerceConnectWrapper" v-if="retailerdata.length > 0">
            <div v-for="(retailer, index) in sortedItems" :key="index">
              <div class="retailer-shop__container">
                <div class="retailer-shop-wrapper">
                  <div class="retailer-shop-img">
                    <img :src="retailer.retailerImage" :alt="retailer.productRetailerItemName" width="130" height="70"
                      class="" />
                  </div>
                  <div class="retailer-shop-name-wrapper">
                    <span class="retailer-name"> {{ retailer.productRetailerItemName }} </span>
                    <span class="retailer-price" v-if="retailer.Price">{{retailer.price}}</span>
                  </div>
                </div>
                <div class="retailer-shop-instock" v-if="retailer.stockAvailability">
                  {{retailer.stockAvailability}}
                </div>
                <div class="retailer-shop-deliveryTime" v-if="retailer.deliveryTime">
                  {{retailerDictionaryDatas.DeliveryTimeLabel}}<strong> {{retailer.deliveryTime}}</strong>
                </div>
                <div class="retailer-shop-buyNow">
                  <a :href="retailer.retailerLink" target="_blank" class="cta cta--light" panel-focusable=""> {{
                    retailer.ctaLabel }}</a> 
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p class="no-product" style="text-align: center;">{{ errorMsg }}</p> 
          </div>
 
        </div>  
      </div> 
    </div> 
  </div>
</template>

<script>
import Slide from '@Feature/Slider/code/Scripts/components/slide/slide';
import Slider from '@Feature/Slider/code/Scripts/components/slider/slider';
import customSorting from '@Feature/CustomSorting/custom-sorting.vue';

export default {
  name: 'routine-finder-product-retailer',
  components: {
    Slide,
    Slider,
    customSorting
  },
  props: {
    retailerdata: {
      type: Object,
      default: []
    },
    errorMsg: {
      type: String,
      default: ''
    },
    ctaLable: {
      type: String,
      default: ''
    },
    retailerDictionaryDatas:{
      type: Object,
      default: []
    }, 
     enableBuynowSortOption:{
      type: Boolean,
      default: false
    }, 
  },
  data() {
    return {
      sortField :'productRetailerItemName',
      smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
      showPopup: false, // Controls popup visibility
      uniqueId: Math.random().toString(36).substring(2),
      selectedInput: '',
      sortOrder: ''
    }
  },
  watch: {
    showPopup(newValue) {
      if (newValue) {
        this.sortOrder = '';
        this.$refs.retailer_sorting.selected = this.retailerDictionaryDatas.defaultText;

      }
    }
  },
  computed: {
    sortedItems() {
      if (!this.sortOrder) return this.retailerdata;
      return [...this.retailerdata].sort((a, b) => {
        if (this.sortOrder === 'asc') {
          return a[this.sortField].localeCompare(b[this.sortField]);
        } else {
          return b[this.sortField].localeCompare(a[this.sortField]);
        }
      });
    }
  },
  methods: {
    openRetailer() {
      this.showPopup = true;
      
    },
    closePopupScreen() {
      this.showPopup = false;
    }, 
  }

};
</script>

<style lang="scss" src="./routine-finder-product-retailer.scss"></style>
<style lang="scss" src="../../../../../LrpRetailer/code/Scripts/components/lrp-retailer.scss"></style>
